// src/stockx/directional/ChevronDownIcon.ts
import { createIcon } from "@chakra-ui/icons";
var ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  viewBox: "0 0 50 50",
  d: "M9.80001 14.2L25 30.4L40.2 14.2001L42.9 16.7001L25 35.8L7.10001 16.7L9.80001 14.2Z"
});
var ChevronDownIcon_default = ChevronDownIcon;

export {
  ChevronDownIcon_default
};
